import About1 from '../../images/about-1.jpg';
import About2 from '../../images/about-2.jpg';
import About3 from '../../images/about-3.jpg';

export const aboutObjOne = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  lightTopLine: false,
  topLine: 'Our Passion',
  headline: 'We believe in making good desserts',
  description:
    'We take the time to make our products with care using the finest ingredients, supporting small business wherever we can. We’re always innovating.',
  buttonLabel: 'Sign Up Now',
  imgStart: 'start',
  img: `${About1}`,
  alt: 'Vault'
};

export const aboutObjTwo = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  lightTopLine: false,
  topLine: 'Join Us',
  headline: 'Grow with us',
  description:
    'We are looking to grow our team, help us reinvent the neighbourhodd cake shop and join us in our love of desserts.',
  buttonLabel: 'Sign Up Now',
  imgStart: 'start',
  img: `${About2}`,
  alt: 'Vault'
};
  
export const aboutObjThree = {
    lightBg: true,
    lightText: true,
    lightTextDesc: false,
    lightTopLine: true,
    topLine: 'Our Philosophy',
    headline: 'Making good food go further',
    description:
      'CakeMe is based on time-honoured techniques and our decades-old starters, nothing gives us as much pleasure as a freshly desserts ans drink, products made with love, we are ordinary people who want to make extraordinary things.',
    buttonLabel: 'Start Now',
    imgStart: '',
    img: `${About3}`,
    alt: 'Vault'
};

  